/* Keep header counts in sync with the theme's successful cart renders. */
(() => {
  'use strict';
  if (window.ByMorningHeaderCartCount) { window.ByMorningHeaderCartCount.sync(); return; }

  function sync(event) {
    const counters = document.querySelectorAll('[data-bm-header-cart-count]');
    // Also normalize markup restored by the editor or browser before the
    // lazy cart exists, so an empty count can never flash in the header.
    counters.forEach(counter => {
      const initial = Number.parseInt(counter.textContent.replace(/[()]/g, ''), 10) || 0;
      counter.textContent = String(initial);
      counter.hidden = initial === 0;
    });
    const cart = document.querySelector('cart-element[data-cart-page]')
      || document.querySelector('cart-element[data-cart-drawer]');
    // The server-rendered header count stays authoritative until lazy loading finishes.
    if (!cart || cart.querySelector('[data-cart-drawer-template]')) return;
    const count = Array.from(cart.querySelectorAll('[data-quantity-field]')).reduce((sum, input) => {
      const quantity = Number.parseInt(input.getAttribute('value'), 10);
      return sum + (Number.isFinite(quantity) ? Math.max(0, quantity) : 0);
    }, 0);
    counters.forEach(counter => {
      const previous = Number.parseInt(counter.textContent, 10) || 0;
      const text = String(count);
      if (counter.textContent !== text) counter.textContent = text;
      counter.hidden = count === 0;
      if (event?.type === 'theme:cart:added' && count > previous
        && !matchMedia('(prefers-reduced-motion: reduce)').matches && counter.getClientRects().length) {
        counter.getAnimations().forEach(animation => animation.cancel());
        counter.animate([{transform: 'scale(1)'}, {transform: 'scale(1.15)'}, {transform: 'scale(1)'}],
          {duration: 240, easing: 'ease-out'});
      }
    });
  }

  window.ByMorningHeaderCartCount = {sync};
  // "added" is emitted after all cart rebuilds, including quantity changes and removals.
  ['theme:cart:loaded', 'theme:cart:added', 'shopify:section:load'].forEach(event => {
    document.addEventListener(event, sync);
  });
  sync();
})();
